import I18n from 'I18n';
import { DEFAULT_LANG, I18N_TO_DEFAULT_LANG } from 'FormsUI/constants/Languages';
import { langToFormsLang } from 'forms-utils-lib/language/langToFormsLang';
import { formsLangToLang } from 'forms-utils-lib/language/formsLangToLang';
import { formsLangToLegalConsentLang } from 'forms-utils-lib/language/formsLangToLegalConsentLang';
import { formsLangToAdConsentLang } from 'forms-utils-lib/language/formsLangToAdConsentLang';
import { LangToFormsLangMap } from 'forms-utils-lib/language/LanguageConstants';
export const getLangToFormsLang = lang => langToFormsLang(I18n, lang);
export const getFormsLangToLang = lang => formsLangToLang(I18n, lang);
export const getFormsLangToLegalConsentLang = lang => formsLangToLegalConsentLang(I18n, lang);
export const getFormsLangToAdConsentLang = lang => formsLangToAdConsentLang(I18n, lang);
export const getIsValidFormsLang = lang => lang ? Object.values(LangToFormsLangMap).includes(lang) : false;
export const getIsValidPublicLanguage = lang => {
  return [
  // @ts-expect-error populated during runtime
  ...Object.keys(I18n.publicLocales),
  // @ts-expect-error populated during runtime
  ...Object.keys(I18n.baseLocales)].includes(lang);
};
export const getDefaultLang = (i18n = I18n) => {
  // @ts-expect-error populated during runtime
  const baseLang = i18n.lang;
  // @ts-expect-error populated during runtime
  const userLocale = i18n.locale;
  // @ts-expect-error populated during runtime
  const langEnabled = i18n.langEnabled;
  if (!langEnabled) return DEFAULT_LANG;
  const mappedLang = I18N_TO_DEFAULT_LANG.find(i => i.lang === baseLang && i.locale === userLocale);
  return mappedLang ? mappedLang.defaultLang : baseLang;
};